/**
 * Tracks display items by property
 * @link https://github.com/DjonnyX/rcx-virtual-list/tree/main/src/lib/src/utils/tracker.ts
 * @author Evgenii Grebennikov
 * @email djonnyx@gmail.com
 */
export class Tracker {
    set displayObjectIndexMapById(v) {
        if (this._displayObjectIndexMapById === v) {
            return;
        }
        this._displayObjectIndexMapById = v;
    }
    get displayObjectIndexMapById() {
        return this._displayObjectIndexMapById;
    }
    get trackMap() {
        return this._trackMap;
    }
    set trackingPropertyName(v) {
        this._trackingPropertyName = v;
    }
    constructor(trackingPropertyName) {
        /**
         * display objects dictionary of indexes by id
         */
        this._displayObjectIndexMapById = {};
        /**
         * Dictionary displayItems propertyNameId by items propertyNameId
         */
        this._trackMap = {};
        this._trackingPropertyName = trackingPropertyName;
    }
    /**
     * tracking by propName
     */
    track(items, components, snapedComponent, direction) {
        var _a;
        if (!items) {
            return;
        }
        const idPropName = this._trackingPropertyName, untrackedItems = [...components], isDown = direction === 0 || direction === 1;
        let isRegularSnapped = false;
        for (let i = isDown ? 0 : items.length - 1, l = isDown ? items.length : 0; isDown ? i < l : i >= l; isDown ? i++ : i--) {
            const item = items[i], itemTrackingProperty = item[idPropName];
            if (this._trackMap) {
                if (this._trackMap.hasOwnProperty(itemTrackingProperty)) {
                    const diId = this._trackMap[itemTrackingProperty], compIndex = this._displayObjectIndexMapById[diId], comp = components[compIndex];
                    const compId = (_a = comp === null || comp === void 0 ? void 0 : comp.current) === null || _a === void 0 ? void 0 : _a.id;
                    if ((comp === null || comp === void 0 ? void 0 : comp.current) && compId === diId) {
                        const indexByUntrackedItems = untrackedItems.findIndex(v => {
                            return v.current && v.current.id === compId;
                        });
                        if (indexByUntrackedItems > -1) {
                            if (snapedComponent === null || snapedComponent === void 0 ? void 0 : snapedComponent.current) {
                                if (item['config']['snapped'] || item['config']['snappedOut']) {
                                    isRegularSnapped = true;
                                    snapedComponent.current.data = item;
                                    snapedComponent.current.show();
                                }
                            }
                            comp.current.data = item;
                            if (snapedComponent === null || snapedComponent === void 0 ? void 0 : snapedComponent.current) {
                                if (item['config']['snapped'] || item['config']['snappedOut']) {
                                    comp.current.hide();
                                }
                                else {
                                    comp.current.show();
                                }
                            }
                            else {
                                comp.current.show();
                            }
                            untrackedItems.splice(indexByUntrackedItems, 1);
                            continue;
                        }
                    }
                    delete this._trackMap[itemTrackingProperty];
                }
            }
            if (untrackedItems.length > 0) {
                const comp = untrackedItems.shift(), item = items[i];
                if (comp === null || comp === void 0 ? void 0 : comp.current) {
                    if (snapedComponent === null || snapedComponent === void 0 ? void 0 : snapedComponent.current) {
                        if (item['config']['snapped'] || item['config']['snappedOut']) {
                            isRegularSnapped = true;
                            snapedComponent.current.data = item;
                            snapedComponent.current.show();
                        }
                    }
                    comp.current.data = item;
                    if (snapedComponent === null || snapedComponent === void 0 ? void 0 : snapedComponent.current) {
                        if (item['config']['snapped'] || item['config']['snappedOut']) {
                            comp.current.hide();
                        }
                        else {
                            comp.current.show();
                        }
                    }
                    else {
                        comp.current.show();
                    }
                    if (this._trackMap) {
                        this._trackMap[itemTrackingProperty] = comp.current.id;
                    }
                }
            }
        }
        if (untrackedItems.length) {
            for (let i = 0, l = untrackedItems.length; i < l; i++) {
                const comp = untrackedItems[i];
                if (comp === null || comp === void 0 ? void 0 : comp.current) {
                    comp.current.hide();
                }
            }
        }
        if (!isRegularSnapped) {
            if (snapedComponent === null || snapedComponent === void 0 ? void 0 : snapedComponent.current) {
                snapedComponent.current.data = null;
                snapedComponent.current.hide();
            }
        }
    }
    untrackComponentByIdProperty(component) {
        if (!component) {
            return;
        }
        const propertyIdName = this._trackingPropertyName;
        if (this._trackMap && component[propertyIdName] !== undefined) {
            delete this._trackMap[propertyIdName];
        }
    }
    dispose() {
        this._trackMap = null;
    }
}
